//Form Validation for submission
const Validator = require("validator");
const isEmpty = require("./is-empty");

export function validateItemERPCode(data) {
  let validationErrors = {};

  data.itemERPCode = !isEmpty(data.itemERPCode) ? data.itemERPCode : "";

  if (Validator.isEmpty(data.itemERPCode)) {
    validationErrors.itemERPCode = "Item ERP Code field is required";
  }

  return {
    validationErrors,
    isValid: isEmpty(validationErrors),
  };
}
